<template>
  <div>
    <span
      :title="!tour.notOptimized && !tour.visits.some(x => x.order === null) ? $gettext('Optimized Tour 😊') : $gettext('This tour has been modified and it IS NOT optimized')"
      style="display: inline-block; width:15px; height:15px; border-radius: 0px; vertical-align: middle;"
      :class="tour.status === 'DRAFT' ? 'bg-danger' : (!tour.notOptimized && !tour.visits.some(x => x.order === null)  ? 'bg-success' : 'bg-warning')"
      v-b-tooltip.hover
    ></span>
    <span class="text-nowrap">
      <b-link :to="{name: 'ToursEdit', params: {id: tour.id}}">{{tour.id | uuid }}</b-link>
      <a href="#" @click.prevent="copyToClipboard(tour.id)" class="text-secondary" title="Copy to Clipboard">
        <font-awesome-icon :icon="['far', 'copy']" />
      </a>
    </span>
    <div v-if="tour.comment">
      <b-button variant="warning" size="sm" v-b-tooltip.hover.html :title="'<div class=text-left>' + $options.filters.brize(tour.comment) + '</div>'">
        <font-awesome-icon icon="comment" size="2x" style="font-size: 16px; vertical-align: middle" />
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToursListItemId',
  props: {
    tour: {
      type: Object,
      required: true
    }
  }
}
</script>
